"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListCountType = void 0;
var ListCountType;
(function (ListCountType) {
    ListCountType[ListCountType["atLeast"] = 0] = "atLeast";
    ListCountType[ListCountType["atMost"] = 1] = "atMost";
    ListCountType[ListCountType["exactly"] = 2] = "exactly";
})(ListCountType || (exports.ListCountType = ListCountType = {}));



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/list-count-type.js
// module id = 1256
// module chunks = 0